export default "__VITE_ASSET__12d6b1bf__"